import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const UpdateKitchenMenu = ({
  status,
  itemId,
  onSendItems
}: {
  status: ENUM_REQUEST_STATUS;
  itemId: string;
  onSendItems: (itemId: string) => void;
}) => {
  const { can } = useRoleContext();
  const canWriteKitchenRequisition = can(InventoryModule.KitchenRequisition, RolePermission.Write);

  const sendItems = () => {
    if (!canWriteKitchenRequisition) return;
    onSendItems(itemId);
  };

  const menuOptions: Partial<
    Record<ENUM_REQUEST_STATUS, { label: string; onClick: () => void }[]>
  > = {
    [ENUM_REQUEST_STATUS.REQUESTED]: [
      {
        label: 'Send Items',
        onClick: sendItems
      }
    ]
  };
  if (!canWriteKitchenRequisition) {
    return null;
  }

  return (
    <div className='flex gap-2'>
      {menuOptions[status]?.map((item, index) => (
        <Button
          key={index}
          variant='outline'
          className='text-xs py-2 px-3 '
          color='primary'
          small
          onClick={item.onClick}>
          {item.label}
        </Button>
      ))}
    </div>
  );
};

export default UpdateKitchenMenu;
